import { render, staticRenderFns } from "./recordFooter.vue?vue&type=template&id=b295b158&scoped=true&"
import script from "./recordFooter.vue?vue&type=script&lang=js&"
export * from "./recordFooter.vue?vue&type=script&lang=js&"
import style0 from "./recordFooter.vue?vue&type=style&index=0&id=b295b158&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b295b158",
  null
  
)

export default component.exports